import moment from 'moment-timezone';
import 'moment/locale/pt-br';

moment.locale('pt-BR');
moment.tz('America/Sao_Paulo');
export default moment;
